/**
 * PLP Product Cards — Discount estimator + Video manager
 * Loaded ONCE globally instead of per product card.
 */
(function () {
  'use strict';

  // ===========================
  // DISCOUNT ESTIMATOR
  // ===========================
  function parsePriceFromText(text) {
    if (!text) return NaN;
    text = String(text).trim();

    var lastDot = text.lastIndexOf('.');
    var lastComma = text.lastIndexOf(',');

    if (lastDot === -1 && lastComma === -1) {
      var onlyDigits = text.replace(/[^0-9]/g, '');
      var n = parseFloat(onlyDigits);
      return Number.isFinite(n) ? n : NaN;
    }

    if (lastDot !== -1 && lastComma !== -1) {
      if (lastDot > lastComma) {
        text = text.replace(/,/g, '');
      } else {
        text = text.replace(/\./g, '').replace(/,/g, '.');
      }
    } else if (lastComma !== -1) {
      var commas = (text.match(/,/g) || []).length;
      if (commas > 1) {
        text = text.replace(/,/g, '');
      } else {
        var parts = text.split(',');
        var rightLen = parts[parts.length - 1].replace(/[^0-9]/g, '').length;
        text = rightLen === 3 ? text.replace(/,/g, '') : text.replace(/,/g, '.');
      }
    } else if (lastDot !== -1) {
      var dots = (text.match(/\./g) || []).length;
      if (dots > 1) {
        text = text.replace(/\./g, '');
      } else {
        var partsDot = text.split('.');
        var rightLenDot = partsDot[partsDot.length - 1].replace(/[^0-9]/g, '').length;
        if (rightLenDot === 3) text = text.replace(/\./g, '');
      }
    }

    text = text.replace(/[^0-9.]/g, '');
    var result = parseFloat(text);
    return Number.isFinite(result) ? result : NaN;
  }

  function getPriceInfoFromCard(cardEl) {
    var price = NaN, compare = NaN;
    if (!cardEl) return { price: price, compare: compare };

    var priceContainer = cardEl.querySelector('.grid-product__price');
    if (priceContainer) {
      price = parsePriceFromText(priceContainer.innerText || priceContainer.textContent);
    }

    var compareEl = cardEl.querySelector('.grid-product__price--original');
    if (compareEl) {
      compare = parsePriceFromText(compareEl.innerText || compareEl.textContent);
    }

    return { price: price, compare: compare };
  }

  // Escribe solo si cambia: cada escritura es un MutationRecord que procesan
  // todos los observers de la página (Clarity, Intelligems, tema).
  function setText(el, text) {
    if (el.textContent !== text) el.textContent = text;
  }

  // Fase de LECTURA de una tarjeta. innerText (dentro de getPriceInfoFromCard)
  // fuerza layout: por eso todas las lecturas van antes que cualquier escritura.
  function readCard(cardEl, discountData) {
    if (!cardEl || !discountData) return null;

    var job = { discountTexts: cardEl.querySelectorAll('.discount-text'), estimatedEl: null, text: null };

    var pid = cardEl.getAttribute('data-product-id');
    var estimatedEl = pid ? cardEl.querySelector('.estimated-price-compared-' + pid) : null;
    if (!estimatedEl) estimatedEl = cardEl.querySelector('[class*="estimated-price-compared-"]');
    if (!estimatedEl) return job;

    var info = getPriceInfoFromCard(cardEl);
    var base = NaN;
    if (Number.isFinite(info.compare) && info.compare > 0) base = info.compare;
    else if (Number.isFinite(info.price) && info.price > 0) base = info.price;
    if (!Number.isFinite(base)) return job;

    var pct = 0;
    if (discountData.tierOne && discountData.tierOne.discountPct) {
      pct = Number(discountData.tierOne.discountPct) || 0;
    }

    var finalPrice = base * (1 - pct / 100);
    job.estimatedEl = estimatedEl;
    job.text = '$ ' + finalPrice.toFixed(2);
    return job;
  }

  // Fase de ESCRITURA.
  function writeCard(job, discountData) {
    if (!job) return;
    for (var i = 0; i < job.discountTexts.length; i++) {
      setText(job.discountTexts[i], discountData.discountCode);
    }
    if (job.estimatedEl) setText(job.estimatedEl, job.text);
  }

  // Antes: lectura (innerText → layout) y escritura intercaladas por tarjeta,
  // un layout forzado por cada una (layout thrashing). Ahora: todas las
  // lecturas, luego todas las escrituras → un solo layout.
  function applyToCards(cards, discountData) {
    var jobs = [];
    for (var i = 0; i < cards.length; i++) jobs.push(readCard(cards[i], discountData));
    for (var j = 0; j < jobs.length; j++) writeCard(jobs[j], discountData);
  }

  function applyToAllCards(discountData) {
    if (!discountData) {
      discountData = (typeof discountTiers === 'function')
        ? discountTiers()
        : { discountCode: 'CYBER', tierThree: { discountPct: 35 } };
    }
    applyToCards(document.querySelectorAll('.grid__item.grid-product'), discountData);
  }

  function initDiscountEstimator() {
    var discountData = (typeof discountTiers === 'function')
      ? discountTiers()
      : { discountCode: 'CYBER', tierThree: { discountPct: 35 } };

    applyToAllCards(discountData);

    var debounceTimer = null;
    var pendingCards = [];

    var observeTarget = document.getElementById('CollectionSection') || document.getElementById('MainContent') || document.body;

    // Solo las tarjetas recién insertadas (scroll infinito, filtros,
    // recomendaciones): antes se recalculaban TODAS las del documento.
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches('.grid__item.grid-product')) {
            pendingCards.push(n);
          } else if (n.querySelectorAll) {
            var inner = n.querySelectorAll('.grid__item.grid-product');
            for (var k = 0; k < inner.length; k++) pendingCards.push(inner[k]);
          }
        }
      }
      if (!pendingCards.length) return;

      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        var cards = pendingCards.filter(function (c) { return c.isConnected; });
        pendingCards = [];
        var dd = (typeof discountTiers === 'function') ? discountTiers() : discountData;
        applyToCards(cards, dd);
      }, 150);
    });

    mo.observe(observeTarget, { childList: true, subtree: true });

    window.addEventListener('popstate', function () {
      setTimeout(function () { applyToAllCards(discountData); }, 60);
    });
    window.addEventListener('hashchange', function () {
      setTimeout(function () { applyToAllCards(discountData); }, 60);
    });

    window.applyCollectionDiscounts = function () {
      var dd = (typeof discountTiers === 'function') ? discountTiers() : discountData;
      applyToAllCards(dd);
    };

    // Se quitó el hook de jQuery ajaxComplete: el único $.ajax que pintaba
    // tarjetas era el scroll infinito (ahora usa fetch) y el MutationObserver de
    // arriba ya cubre cualquier tarjeta insertada. El otro $.ajax del tema es
    // el getJSON('/cart.js') de header-icons.liquid, que no pinta tarjetas.
    // Recalculaba todo el grid otra vez, 90 ms después de cada página.
  }

  // ===========================
  // PLP VIDEO MANAGER
  // ===========================
  function initVideoManager() {
    var videos = document.querySelectorAll('video.js-plp-video');
    if (!videos.length) return;

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var entry = entries[i];
        var v = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
          var p = v.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        } else {
          try { v.pause(); } catch (e) {}
        }
      }
    }, { threshold: [0, 0.6] });

    for (var i = 0; i < videos.length; i++) {
      io.observe(videos[i]);
    }

    // Observe new videos added via infinite scroll
    var videoObsTarget = document.getElementById('CollectionSection') || document.getElementById('MainContent') || document.body;
    var bodyObs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        if (!added) continue;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          var newVideos = node.querySelectorAll ? node.querySelectorAll('video.js-plp-video') : [];
          for (var k = 0; k < newVideos.length; k++) {
            io.observe(newVideos[k]);
          }
        }
      }
    });
    bodyObs.observe(videoObsTarget, { childList: true, subtree: true });
  }

  // ===========================
  // INIT
  // ===========================
  function init() {
    initDiscountEstimator();
    initVideoManager();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
